module.exports = __webpack_public_path__ + "assets/402357854aba786094e89e4a024005dc.mp3";